export const Name = 'Xpump'
export const Description = 'Meme The World Better'
export const Icon = location.origin + '/static/images/logo.png'

export const ContactAddress = {
  // Email: 'contact@openhub.network',
  Telegram: 'https://t.me/XpumpClub/1',
  Twitter: 'https://x.com/Xpumpcoin',
  TwitterName: '@XPumpcoin',
  // Instagram: '@OpenHub',
  // Tiktok: '@OpenHub',
  // Gitbook: 'https://terminuss-organization.gitbook.io/terminus-project-file',
  // DevDocs: 'https://www.npmjs.com/package/@terminusbet/bet-sdk'
}

// export const DocsUrl =
//   'https://terminuss-organization.gitbook.io/terminus-project-file'

// export const Copyright = '©BETSOL ' + new Date().getFullYear()

// export const GitBookLink = {
//   MegaAirdropEvent:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/mega-airdrop-event',
//   'Dual-platformMiningEvent':
//     'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/dual-platform-mining-event',
//   InflunenceMiningEvent:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/influence-mining-event',
//   LiquidityCoCreationEvent:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/liquidity-co-creation-event',
//   PrivacyPolicy:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/legal-and-policies/privacy-notice',
//   TermsOfService:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/legal-and-policies/terms-of-use',
//   Fee: 'https://terminuss-organization.gitbook.io/terminus-project-file/core-mechanisms/graduation-reward',
//   MiningPointForDualPlatformUsers:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/dual-platform-mining-event',
//   InfluenceMiningEvent:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/terminus-launch-event/influence-mining-event',
//   ContactUs:
//     'https://terminuss-organization.gitbook.io/terminus-project-file/community/contact-us'
// }
